module.exports = __webpack_public_path__ + "static/media/flag-ur.06f0e8e1.webp";